
// ************************************ WINDOW LOAD: ************************************
/* ***************** INDICE DE MÉTODOS: ***************** 
    1. Comprobación de estado de la actual pregunta 
    2. Detección de cambio de pregunta 
*/

/**
 * 1. Comprobación de estado de la actual pregunta
 *    Este metodo se usará en la pantalla de pregunta de los ipads
 * @param {String} quizz_id ID de la pregunta actual
 * @param {String} edition_slug Slug de la edición actual
 * @param {String} edition_id Id de la edición actual
 * @param {Boolean} infinteLoop Determina si ejecutar la funcion indefinidamente
 */
window.reloadPageStatusQuizzV2 = async (quizz_id,edition_slug,edition_id, infinteLoop = true) => {
    console.log(`web.js: /statusquizz/${quizz_id}/${edition_id}`);
    var promise = await fetch(`/statusquizz/${quizz_id}/${edition_id}`);
    var response = await promise.json();
    if (response && response.status == false) {
        window.location.replace(`/place/${edition_slug}`)
    }else{
        if (infinteLoop) {
            setTimeout(() => {
                reloadPageStatusQuizzV2(quizz_id,edition_slug,edition_id)
            }, 2500);
        }
    }
}

/**
 * 2. Detección de cambio de pregunta
 *    Este metodo se usara en la pantalla de espera de los ipads
 * @param {String} edition_id ID de la edición actual
 * @param {Boolean} infinteLoop Determina si ejecutar la funcion indefinidamente
 */
window.reloadPageGetquizzV2 = async (edition_id, infinteLoop = true) => {
    console.log("web.js: /getquizz/"+edition_id);
    var promise = await fetch(`/getquizz/${edition_id}`)
    var response = await promise.json()
    if (response && !window.location.pathname.includes(response)) {
        window.location.replace(response)
    }else{
        if (infinteLoop) {
            setTimeout(() => {
                reloadPageGetquizzV2(edition_id)
            }, 2500);
        }
    }
}